module.exports = __webpack_public_path__ + "img/HR.746be2c9.svg";